import { render, staticRenderFns } from "./AppReferal.vue?vue&type=template&id=31290b4a&scoped=true&"
import script from "./AppReferal.vue?vue&type=script&lang=js&"
export * from "./AppReferal.vue?vue&type=script&lang=js&"
import style0 from "./AppReferal.vue?vue&type=style&index=0&id=31290b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31290b4a",
  null
  
)

export default component.exports